import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { Footer } from '@/components/Footer';
import { PublicTopNavBar } from '@/components/PublicTopNavBar';
import { ScrollToPagePosition } from '@/components/ScrollToPagePosition';
import { PublicSpotterMap } from '@/components/map/PublicSpotterMap';

export const PublicMapLayout = () => {
    return (
        <>
            <ScrollToPagePosition />
            <Stack
                sx={{
                    backgroundColor: '#d0d5dd10',
                    height: '100vh',
                }}
            >
                <PublicTopNavBar />
                <Box flexGrow={1} overflow="hidden">
                    <PublicSpotterMap />
                </Box>
                <Footer marginTop={0.5} />
            </Stack>
        </>
    );
};
